import { useEffect, useState } from "react";
import {
  Button,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { UseAdvCustomer } from "./UseAdvCustomer";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditAdvCustomer(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [customer, setCustomer] = useState();
  const { validate, updateAdvCustomer, getAdvCustomerByID } = UseAdvCustomer();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    companyName: undefined,
    contactPoint: undefined,
    contactPointMobile: undefined,
    economicCode: undefined,
    nationalCode: undefined,
    postalCode: undefined,
    address: undefined,
    registerNO: undefined,
    phone: undefined,
    isOfficial: false,
  });

  const [errorState, setErrorState] = useState({
    companyName: false,
    contactPointMobile: false,
  });

  useEffect(() => {
    if (location.state && location.state.id) {
      setProgress(true);
      getAdvCustomerByID(location.state.id, (customer) => {
        setState(customer);
      });
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        title: "تبلیغات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/advertismentcustomers" },
          {
            name: "ویرایش مشتری",
            url: "/advertismentcustomers/editAdvCustomer",
          },
        ],
      }}
    >
      {!customer ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.companyName ? state.companyName : ""}
              error={errorState.companyName}
              label="نام شرکت"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  companyName: evt.target.value,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.contactPoint ? state.contactPoint : ""}
              label="نام مشتری"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  contactPoint: evt.target.value,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.contactPointMobile ? state.contactPointMobile : ""}
              label="موبایل"
              size="small"
              error={errorState.contactPointMobile}
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  contactPointMobile: evt.target.value,
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <FormControlLabel
              checked={state.isOfficial ? state.isOfficial : false}
              onChange={(evt) => {
                setState({ ...state, isOfficial: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="فاکتور به صورت رسمی ارسال شود"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              disabled={!state.isOfficial}
              fullWidth
              value={state.address ? state.address : ""}
              label="آدرس"
              multiline
              rows={3}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, address: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}

          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              disabled={!state.isOfficial}
              fullWidth
              value={state.phone ? state.phone : ""}
              label="تلفن"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  phone: evt.target.value,
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              disabled={!state.isOfficial}
              fullWidth
              value={state.economicCode ? state.economicCode : ""}
              label="کد اقتصادی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  economicCode: evt.target.value,
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              disabled={!state.isOfficial}
              fullWidth
              value={state.nationalCode ? state.nationalCode : ""}
              label="شناسه ملی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  nationalCode: evt.target.value,
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              disabled={!state.isOfficial}
              fullWidth
              value={state.postalCode ? state.postalCode : ""}
              label="کد پستی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  postalCode: evt.target.value,
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              disabled={!state.isOfficial}
              fullWidth
              value={state.registerNO ? state.registerNO : ""}
              label="شماره ثبت"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  registerNO: evt.target.value,
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}

          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateAdvCustomer(state, () => {
                    navigate("/advertismentcustomers", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/advertismentcustomers", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
